import React from 'react';
// import StockTable from '../components/stock/StockTable';
import {StockTable} from '../components/Stock/StockTable';

export const StockScreen = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Stock Overview</h1>
      {/* Render your table component here */}
      <StockTable /> 
    </div>
  );
};